// extracted by mini-css-extract-plugin
module.exports = {"root":"CustomDrawerContent_root__2X0Vn","content":"CustomDrawerContent_content__yjqO6"};